import { createFileRoute } from '@tanstack/react-router';

import { NexusLibraryPage } from '@/features/nexus/library/NexusLibraryPage';
import { PageLayout } from '@/features/page-layout/PageLayout';

export const Route = createFileRoute('/_protected/t/$tenantId/nexus/library')({
  component: NexusLibraryRoute,
});

function NexusLibraryRoute() {
  return (
    <PageLayout>
      <NexusLibraryPage />
    </PageLayout>
  );
}
